import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Auth } from '../../providers/auth';
import { LoadingController } from 'ionic-angular';
import { HomePage } from '../home/home'; 
import { AboutPage } from '../about/about'; 
import { LoginPage } from '../login/login'; 
import { DisclaimerPage } from '../disclaimer/disclaimer'; 


// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-register',
  templateUrl: 'register.html'
})
export class RegisterPage {
  username: string;
  password: string;
  email: string;
  errorMessage: string;
  loader:any;
  iagree: boolean;
  fullname:string;
  sex:string;
  education:string;
  dob: string;

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public translate: TranslateService, public navCtrl: NavController, private storage: Storage, public auth: Auth, public loadingCtrl: LoadingController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);
    
    this.errorMessage="";
    this.username="";
    this.password="";
    this.email="";
    this.iagree=false;
    this.fullname="";
    this.sex="";
    this.education="";
    this.dob="";
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(false);
  }

  goToLogin(){
    this.navCtrl.pop();
    //this.navCtrl.push(LoginPage, {});
  }

  goToDisclaimer(){
    this.navCtrl.push(DisclaimerPage, {});
  }

  register(){
    if(this.functions.deviceIsOnline()){
      this.presentLoading();
        this.auth.register(this.username,this.password,this.email,this.fullname,this.sex,this.dob,this.education).then((response)=>{
          var responseString:string;
          responseString=response.toString();
          if(responseString.indexOf('RegisterResIsOk')!=-1){
            this.navCtrl.setRoot(LoginPage, {});
           }else{
             this.errorMessage=this.auth.errorMessage;
             this.loader.dismiss();
             return;
          }
        });
    }else{
      this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
    }
  }

  presentLoading() {
    this.loader = this.loadingCtrl.create({
      content: "Caricamento..."
    });
    this.loader.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts